package com.essntl.features.crm.data.supabase

import com.essntl.features.crm.domain.model.CreateContactModel
import com.essntl.features.supplier.data.supabase.SupplierDto
import com.essntl.features.travelagent.data.supabase.TravelAgentDto
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateContactDto(
    @SerialName("travel_agent")
    val travelAgent: TravelAgentDto? = null,
    val supplier: SupplierDto? = null,
) {
    fun toModel() =
        CreateContactModel(
            travelAgent = travelAgent?.toModel(),
            supplier = supplier?.toModel(),
        )
}